window.aeloraPrivacyReady = window.aeloraPrivacyReady || new Promise((resolve, reject) => {
  const timer = setTimeout(() => reject(new Error('Privacy API timeout')), 5000);
  const ready = () => { clearTimeout(timer); resolve(window.Shopify.customerPrivacy); };
  if (window.Shopify?.customerPrivacy) { ready(); return; }
  if (!window.Shopify?.loadFeatures) { clearTimeout(timer); reject(new Error('Privacy loader unavailable')); return; }
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (error || !window.Shopify.customerPrivacy) { clearTimeout(timer); reject(error || new Error('Privacy API unavailable')); return; }
    ready();
  });
});
window.aeloraPrivacyReady.catch(() => {});
document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'cookieConsent';
  const ANIMATION_DURATION = 300;

  const banner = document.getElementById('cookie-banner');
  if (!banner) return;

  const modal = banner.querySelector('.cb-modal');
  const modalPanel = banner.querySelector('.cb-modal__panel');
  const consentInputs = [...banner.querySelectorAll('[data-cb-consent]')];
  let previouslyFocusedElement = null;

  // TODO: Replace localStorage consent persistence with the Shopify Customer Privacy API.
  const storeConsent = (consent) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch (error) {
      console.warn('Cookie preferences could not be stored.', error);
    }
  };

  const loadStoredConsent = () => {
    try {
      const storedConsent = localStorage.getItem(STORAGE_KEY);
      return storedConsent ? JSON.parse(storedConsent) : null;
    } catch (error) {
      console.warn('Stored cookie preferences could not be loaded.', error);
      return null;
    }
  };

  const showBanner = () => {
    banner.hidden = false;
    window.requestAnimationFrame(() => {
      banner.classList.remove('cb-banner--hiding');
      banner.classList.add('cb-banner--visible');
    });
  };

  const hideBanner = () => {
    banner.classList.remove('cb-banner--visible');
    banner.classList.add('cb-banner--hiding');
    window.setTimeout(() => {
      banner.hidden = true;
      banner.classList.remove('cb-banner--hiding');
    }, ANIMATION_DURATION);
  };

  const applyConsentToInputs = (consent) => {
    consentInputs.forEach((input) => {
      input.checked = Boolean(consent?.[input.dataset.cbConsent]);
    });
  };

  const openPreferences = () => {
    if (!modal || !modalPanel) return;

    previouslyFocusedElement = document.activeElement;
    applyConsentToInputs(loadStoredConsent());
    modal.hidden = false;
    window.requestAnimationFrame(() => {
      modal.classList.add('cb-modal--visible');
      modalPanel.focus();
    });
  };

  const closePreferences = () => {
    if (!modal) return;

    modal.classList.remove('cb-modal--visible');
    window.setTimeout(() => {
      modal.hidden = true;
      previouslyFocusedElement?.focus();
      previouslyFocusedElement = null;
    }, ANIMATION_DURATION);
  };

const completeConsent = async (consent) => {
  try {
    const privacy = await window.aeloraPrivacyReady;
    await new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Consent registration timeout')), 5000);
      privacy.setTrackingConsent({
        analytics: Boolean(consent.analytics), marketing: Boolean(consent.marketing),
        preferences: Boolean(consent.preferences), sale_of_data: false
      }, () => { clearTimeout(timer); resolve(); });
    });
    storeConsent({ necessary: true, ...consent, updatedAt: new Date().toISOString() });
    closePreferences(); hideBanner();
  } catch (error) { console.warn('Cookie preferences were not registered', error); showBanner(); }
};

  const acceptAll = () => {
    completeConsent({ analytics: true, marketing: true, preferences: true });
  };

  const rejectAll = () => {
    completeConsent({ analytics: false, marketing: false, preferences: false });
  };

  const savePreferences = () => {
    const preferences = Object.fromEntries(
      consentInputs.map((input) => [input.dataset.cbConsent, input.checked]),
    );
    completeConsent(preferences);
  };

  const handleAction = (event) => {
    const action = event.target.closest('[data-cb-action]')?.dataset.cbAction;
    const actions = {
      accept: acceptAll,
      reject: rejectAll,
      manage: openPreferences,
      save: savePreferences,
      cancel: closePreferences,
    };

    actions[action]?.();
  };

  const initializeBanner = async () => {
    banner.addEventListener('click', handleAction);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closePreferences();
    });

    const storedConsent = loadStoredConsent();
    try {
      const privacy = await window.aeloraPrivacyReady;
      const registered = privacy.currentVisitorConsent();
      if (storedConsent && ['analytics', 'marketing', 'preferences'].every(key =>
        registered[key] === (storedConsent[key] ? 'yes' : 'no'))) {
        applyConsentToInputs(storedConsent);
        return;
      }
    } catch (error) { console.warn('Cookie consent status unavailable', error); }
    showBanner();
  };

  initializeBanner();
});
